<template>
  <div>
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />
      </b-col>

      <!-- Content Right -->
      <b-col class="content-header-right text-md-right" md="3" cols="12">
        <b-button
            @click="showFormModal(null)"
            class="px-3 text-capitalize"
            variant="primary"
        >
          <feather-icon size="16" icon="PlusIcon" class="mr-50" />
          ایجاد مقررات تور
        </b-button>
      </b-col>
    </b-row>
    <div v-if="regulations">
      <div class="d-flex justify-content-between align-items-center">
        <per-page class="col-sm-12 col-md-3 col-lg-2" v-model="perPage" />
        <!-- <search
          ref="residencesSearchComponent"
          class="w-50"
          v-model="searchInput"
        /> -->
      </div>

      <b-table-simple responsive>
        <b-thead>
          <b-tr>
            <!-- <b-th>عکس آیکن</b-th>
            <b-th>آیکن</b-th> -->
            <b-th>عنوان</b-th>
            <b-th>توضیحات</b-th>
            <b-th>تاریخ</b-th>
            <b-th>وضعیت</b-th>
            <b-th>عملیات</b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr v-for="regulation in regulations" :key="regulation.id">
            <!-- <b-th>
              <img
              v-if="regulation.image"
                style="border-radius: 15px; width: 35px"
                :src="$http.defaults.fileUrl + regulation.image.path"
            /></b-th>
            <b-th >{{ regulation.icon }}</b-th> -->
            <b-td>{{ regulation.name }}</b-td>
            <b-td>{{ regulation.description }}</b-td>
            <b-td>
              {{
                new Date(regulation.created_at).toLocaleString("fa-IR", {
                  timeZone: "Iran",
                })
              }}
            </b-td>
            <b-td>
              <b-col
                  class="d-flex align-items-center pl-0"
                  :class="
                  regulation.status != 'active' ? 'text-danger' : 'text-success'
                "
              >
                {{ regulation.status == "active" ? "" : "غیر" }}فعال
              </b-col></b-td
            >
            <b-td>
              <b-col class="d-flex align-items-center">
<!--                <b-button
                    @click="showConfirmModal(regulation)"
                    variant="flat-danger"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Trash2Icon" size="20" />
                </b-button>-->
                <b-button
                    @click="showFormModal(regulation)"
                    variant="flat-secondary"
                    class="font-weight-bolder"
                >
                  <feather-icon icon="Edit2Icon" size="20" />
                </b-button> </b-col
              ></b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
      <pagination
          ref="residencesPaginationComponent"
          v-model="page"
          :paginationData="paginationData"
      />
    </div>
    <b-sidebar
        width="500px"
        v-model="formModal"
        right
        backdrop
        shadow
        bg-variant="white"
    >
      <template #header>
        <div class="w-100">
          <div class="text-right">
            <b-button
                style="background-color: rgba(75, 75, 75, 0.12)"
                @click="formModal = false"
                variant="flat-dark"
                class="btn-icon rounded-circle mr-1"
            >
              <feather-icon icon="XIcon" size="20" />
            </b-button>
          </div>
          <div class="mr-1 sidebarHeaderTitleDiv">
            <h3 class="text-capitalize">
              {{ editMode ? "ویرایش مقررات تور" : "ایجاد مقررات تور" }}
            </h3>
          </div>
        </div>
      </template>
      <b-container class="">
        <b-form-group class="mt-1">
          <label for="name" class="text-capitalize"> عنوان : </label>
          <b-form-input @input="removeErrors('name')" id="name" v-model="regulationInput.name" type="text" />
          <ErrorMessage
              errorType="name"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="slug" class="text-capitalize"> اسلاگ | slug : </label>
          <b-form-input @input="removeErrors('slug')" id="slug" v-model="regulationInput.slug" type="text" />
          <ErrorMessage
              errorType="slug"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1 col-md-6" v-slot="{ ariaDescribedby }">
          <label for="province_status" class="text-capitalize"> وضعیت : </label>
          <b-form-checkbox
              v-model="regulationInput.status"
              :aria-describedby="ariaDescribedby"
              value="active"
              @input="removeErrors('status')"
          >فعال</b-form-checkbox
          >
          <b-form-checkbox
              v-model="regulationInput.status"
              :aria-describedby="ariaDescribedby"
              value="inactive"
              @input="removeErrors('status')"
          >پیش نویس</b-form-checkbox
          >
          <ErrorMessage
              errorType="status"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="mt-1">
          <label for="description" class="text-capitalize"> توضیحات : </label>
          <b-form-input
              id="description"
              v-model="regulationInput.description"
              type="text"
              @input="removeErrors('description')"
          />
          <ErrorMessage
              errorType="description"
              :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <!-- <b-form-group class="mt-1">
          <label for="body" class="text-capitalize"> آیکن : </label>
          <b-form-input @input="removeErrors('icon')"  id="body" v-model="regulationInput.body" type="text" />
              <ErrorMessage
            errorType="icon"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group>
        <b-form-group class="">
          <label for="imageIcon" class="text-capitalize">
            آپلود تصویر ایکون:
          </label>
          <FilePicker
            @inputFile="inputIconImageFile"
            :url="iconImageurl"
            ref="iconImageFilePicker"
          ></FilePicker>
          <ErrorMessage
            errorType="image"
            :errorMessages="errorMessage"
          ></ErrorMessage>
        </b-form-group> -->
      </b-container>
      <template #footer>
        <div class="d-flex align-items-center justify-content-end px-2 py-1">
          <b-button
              class="text-capitalize mr-2"
              @click="formModal = false"
              variant="outline-dark"
          >
            {{ $t("cancel") }}
          </b-button>
          <b-button variant="primary" @click="submitForm()">
            <div v-if="submitLoading" class="px-1">
              <b-spinner small style="width: 1.3rem; height: 1.3rem" />
              <span class="sr-only">Loading...</span>
            </div>
            <span v-else class="text-capitalize">
              {{ $t("submit") }}
            </span>
          </b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormCheckbox,
  BTableSimple,
  BThead,
  BTbody,
  BTr,
  BTh,
  BTd,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import ErrorMessage from "@/components/ErrorMessage.vue";
import FilePicker from "@/components/FilePicker.vue";

export default {
  components: {
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    ErrorMessage,
    BFormCheckbox,
    FilePicker,
    BTableSimple,
    BThead,
    BTbody,
    BTr,
    BTh,
    BTd,
  },
  data() {
    return {
      iconImageurl:"",
      errorMessage: {},
      perPage: 10,
      page: 1,
      buildings: [],
      regulations: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },
      companies: [],
      buildingsCancelToken: undefined,
      regulationInput: {
        id: "",
        name: "",
        slug:"",
        description: "",
        status:"",
        // image: null,
        // icon: "",
      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.$store.commit("verticalMenu/UPDATE_VERTICAL_MENU_COLLAPSED", false);
    this.getRegulations();
  },
  watch: {
    searchInput(value) {
      this.page = 1;
      this.getRegulations();
    },
    perPage(value) {
      this.page = 1;
      this.getRegulations();
    },
    page(value) {
      this.getRegulations();
    },
  },
  methods: {
    inputIconImageFile(file) {
      this.removeErrors("image");
      this.regulationInput.image = file;
    },
    removeErrors(data) {
      if (
          typeof this.errorMessage[data] !== "undefined" &&
          this.errorMessage[data].length > 0
      ) {
        // this.errorMessage[data][0]="salllam"
        delete this.errorMessage[data];
        this.errorMessage = Object.assign(
            {},
            this.errorMessage,
            this.errorMessage
        );
        console.log(data, this.errorMessage);
      }
    },
    sort(args) {
      this.page = 1;
      this.sortBy = args.sortBy;
      this.sortDir = args.sortDir;
      this.getRegulations();
    },

    async getRegulations() {
      if (typeof this.cancelToken != typeof undefined) {
        this.cancelToken.cancel("Operation canceled due to new request.");
      }
      //Save the cancel token for the current request
      this.cancelToken = this.$http.CancelToken.source();

      let data = {
        // search: this.searchInput,
        // per_page: this.perPage,
        // page: this.page,
        // sort_by: this.sortBy,
        // sort_dir: this.sortDir,
      };

      const requestData = {
        method: "get",
        url: "/admin/tours/regulations",
        // params: data,
        // cancelToken: this.cancelToken.token,
      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.regulations = data.data;
            this.paginationData = data.meta;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    showConfirmModal(regulation) {
      this.$bvModal
          .msgBoxConfirm(
              `آیا از حذف مقررات اقامتگاه مطمئن هستید ؟  : ${regulation.name}.`,
              {
                title: this.$t("Please Confirm"),
                size: "sm",
                okVariant: "primary",
                okTitle: this.$t("Yes"),
                cancelTitle: this.$t("No"),
                cancelVariant: "outline-secondary",
                hideHeaderClose: false,
                centered: true,
              }
          )
          .then(async (confirmed) => {
            if (confirmed) {
              let residenceIndex = 0;
              this.regulations = await this.regulations.filter(
                  (residenceItem, index) => {
                    if (residenceItem.id == regulation.id) {
                      residenceIndex = index;
                    }
                    return residenceItem.id !== regulation.id;
                  }
              );

              const requestData = {
                method: "delete",
                url: `/admin/tours/regulations/${regulation.id}`,
              };
              this.$http(requestData)
                  .then((response) => {
                    this.$bvToast.toast(
                        `مقررات اقامتگاه: ${regulation.name}  با موفقیت حذف شد.`,
                        {
                          title: this.$t("Done"),
                          variant: "success",
                          solid: true,
                        }
                    );
                  })
                  .catch((err) => {
                    let message = this.$t("Unable to delete!");
                    if (
                        err.response &&
                        err.response.data &&
                        err.response.data.message
                    )
                      message = err.response.data.message;
                    this.$bvToast.toast(message, {
                      title: this.$t("Error"),
                      variant: "danger",
                      solid: true,
                    });
                    this.regulations.splice(residenceIndex, 0, regulation);
                  });
            }
          });
    },
    showFormModal(regulation) {
      if (regulation) {
        this.regulationInput = {
          id: regulation.id,
          name: regulation.name,
          slug:regulation.slug,
          description: regulation.description,
          status: regulation.status,
          // image: null,
          // icon: regulation.icon,
        };
        // this.$refs.iconImageFilePicker.clearFileInput()
        // this.iconImageurl=regulation.image.path
        this.editMode = true;
      } else {
        this.regulationInput = {
          name: "",
          slug: "",
          description: "",
          status: "",
          // image: "",
          // icon: "",
        };
        // this.$refs.iconImageFilePicker.clearFileInput()
        // this.iconImageurl=""
        this.editMode = false;
      }
      this.formModal = true;
    },
    submitForm() {
      if (this.submitLoading) return;
      let errorMessage = null;
      if (!errorMessage && !this.regulationInput.name) {
        errorMessage = "لطفا نام مقررات اقامتگاه را وارد کنید";
      }
      if (!errorMessage && !this.regulationInput.slug) {
        errorMessage = "لطفا اسلاگ مقررات اقامتگاه را وارد کنید";
      }

      let formData = new FormData();

      if (this.regulationInput.name) {
        formData.append("name", this.regulationInput.name);
      }
      if (this.regulationInput.slug) {
        formData.append("slug", this.regulationInput.slug);
      }
      if (this.regulationInput.status) {
        formData.append("status", this.regulationInput.status);
      }
      if (this.regulationInput.description) {
        formData.append("description", this.regulationInput.description);
      }
      // if (this.regulationInput.image) {
      //   formData.append("image", this.regulationInput.image);
      // }
      // if (this.regulationInput.icon) {
      //   formData.append("icon", this.regulationInput.icon);
      // }
      if (errorMessage) {
        this.$bvToast.toast(errorMessage, {
          title: this.$t("Error"),
          variant: "danger",
          solid: true,
        });
        return;
      }

      this.submitLoading = true;

      const requestData = {
        method: this.editMode ? "put" : "post",
        url: this.editMode
            ? `/admin/tours/regulations/${this.regulationInput.id}`
            : `/admin/tours/regulations`,
        data: this.regulationInput,
      };

      this.$http(requestData)
          .then((response) => {
            let message = "مقررات اقامتگاه با موفقیت اضافه شد";
            if (this.editMode) message = "مقررات اقامتگاه با موفقیت ویرایش شد";
            this.$bvToast.toast(message, {
              title: this.$t("Done"),
              variant: "success",
              solid: true,
            });
            if (!this.editMode && this.buildings && this.buildings.length > 0) {
              this.$refs.residencesPaginationComponent.clear();
              // this.$refs.residencesSearchComponent.clear();
              this.$refs.residencesTableHeadComponent.clear();
              this.page = 1;
              this.searchInput = "";
              this.sortBy = "";
              this.sortDir = "";
            }

            this.submitLoading = false;
            this.formModal = false;
            this.getRegulations();
          })
          .catch((err) => {
            let message = "خطا در ایجاد مقررات اقامتگاه";
            if (this.editMode) message = "خطا در ویرایش مقررات اقامتگاه";
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.message
            )
              message = err.response.data.response.message;
            if (
                err.response &&
                err.response.data &&
                err.response.data.response &&
                err.response.data.response.meta &&
                err.response.data.response.meta.errors
            )
              this.errorMessage = err.response.data.response.meta.errors;
            console.log("this.errorMessage", this.errorMessage);

            this.$bvToast.toast(message, {
              title: this.$t("Error"),
              variant: "danger",
            });
            this.submitLoading = false;
            console.log(err);
          });
    },

  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
